import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ViewButton = ({ link }) => {
  const { t: translate } = useTranslation();

  return (
    <div style={{ display: 'flex' }}>
      <Link to={link}>
        <StyledButton className="d-flex align-items-center gap-1">
          <i className="bx bx-show" style={{ color: '#495057' }} />
          <span style={{ color: 'rgba(106, 113, 135, 1)' }}>{translate('See')}</span>
        </StyledButton>
      </Link>
    </div>
  );
};

const StyledButton = styled(Button)`
  border: none;
  background-color: #e0e0e0;

  :hover {
    background-color: #d5d5d5;
  }
`;

ViewButton.propTypes = {
  link: PropTypes.string.isRequired,
};

export default ViewButton;
